
<template>
  <div class="main-content">
    <Container
      :title="t('route.templatePreset')"
      :hasLine="true"
    >
      <template #header>
        <SearchForm
          ref="searchFormRef"
          :formModel="searchFormModel"
          :formStruct="searchFormStruct"
          :submitButton="t('common.search')"
          :resetButton="t('common.reset')"
          @submit="submitSearch"
          @reset="resetForm"
        />
      </template>
      <template #main>
        <el-button
          v-if="this.$hasPermission(['ACTION_vcTemplatePresetEdit'])"
          @click="handleCreate()"
          type="success"
        >
          {{ t('table.add') }}
        </el-button>
        <el-button
          v-if="selection.length > 0 && this.$hasPermission(['ACTION_vcTemplatePresetEdit'])"
          @click="handleBathDelete()"
          type="danger"
        >
          {{ t('table.bathDelete') }}
        </el-button>
        <SimpleTable
          :isLoading="listLoading"
          :tableData="tableData"
          :columnStruct="columnStruct"
          :sort="sort"
          :order="order"
          :operateColumnWidth="300"
          @handleOrder="handleOrder"
          @handleSelection="handleSelection"
        >
          <template
            v-if="this.$hasPermission(['ACTION_vcTemplatePresetEdit'])"
            #default="slotProps"
          >
            <el-button
              @click="handleEdit(slotProps.row)"
              type="primary"
              size="mini"
            >
              {{ t('common.edit') }}
            </el-button>
            <el-button
              @click="handleEditThumbnail(slotProps.row)"
              type="primary"
              size="mini"
            >
              {{ t('templatePreset.editThumbnail') }}
            </el-button>
            <el-button
              @click="handleDelete(slotProps.row.id)"
              type="danger"
              size="mini"
            >
              {{ t('common.delete') }}
            </el-button>
          </template>
        </SimpleTable>
        <el-pagination
          :total="total"
          v-show="total > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          :current-page="page"
          :page-sizes="[5, 10, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right;"
        />
      </template>
    </Container>
    <el-dialog
      v-if="this.$hasPermission(['ACTION_vcTemplatePresetEdit'])"
      :title="t(textMap[dialogStatus])"
      center
      v-model="dialogFormVisible"
      width="45%"
    >
      <NomalContainer>
        <CenterForm
          v-if="dialogStatus === 'create'"
          :formModel="createModel"
          :formStruct="createStruct"
          :formRules="templatePresetCreateRole"
          @submit="createSubmit"
          @reset="createReset"
        >
          <template #default="slotProps">
            <UploadFormItem
              class="is-required"
              ref="createUpload"
              prop="labelThumbnail"
              :data="{data: JSON.stringify(createModel)}"
              :label="t('templatePreset.labelThumbnail')"
              :fileName="slotProps.row.labelThumbnail"
              :action="getCreateUploadUri()"
              :headers="getUploadHeader()"
              @upload="handleCreateUpload"
            />
          </template>
        </CenterForm>
        <CenterForm
          v-if="dialogStatus === 'update'"
          :formModel="updateModel"
          :formStruct="updateStruct"
          :formRules="templatePresetRole"
          @submit="updateNameSubmit"
          @reset="updateNameReset"
        />
        <template v-if="dialogStatus === 'updateThumbnail'">
          <div style="width:100%;padding:15px;display:flex;justify-content: center;">
            <div style="width:100%">
              <el-form
                label-width="100px"
                :model="updateThumbnailModel"
              >
                <UploadFormItem
                  class="is-required"
                  ref="updateUpload"
                  prop="labelThumbnail"
                  :data="{id: updateThumbnailModel.id}"
                  :label="t('templatePreset.labelThumbnail')"
                  :fileName="updateThumbnailModel.labelThumbnail"
                  :action="getUpdateUploadUri()"
                  :headers="getUploadHeader()"
                  @upload="handleUpdateUpload"
                />
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="updateThumbnailSubmit"
                  >
                    {{ t('common.submit') }}
                  </el-button>
                  <el-button
                    @click="updateThumbnailReset"
                  >
                    {{ t('common.reset') }}
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </template>
      </NomalContainer>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { ElForm, ElMessage, ElMessageBox, ElLoading } from 'element-plus'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import NomalContainer from '@/components/dfms-components/container/NomalContainer.vue'
import UploadFormItem from '@/components/form/common/UploadFormItem.vue'
import {
  TemplatePresetModel,
  TemplatePresetPageSearchModel,
  TemplatePresetSearchModel,
  TemplatePresetAddModel,
  TemplatePresetUpdateModel,
  TemplatePresetViewModel,
  IdsModel
} from '@/model/product/TemplatePresetModel'
import {
  pageSearchTemplatePreset,
  // addTemplatePreset,
  updateTemplatePreset,
  removeTemplatePreset,
  batchRemoveTemplatePreset
} from '@/apis/product/templatePreset'
import { IndustryAndCategorySearchModel } from '@/model/product/IndustryAndCategoryModel'
import { searchIndustryAndCategory } from '@/apis/product/industryAndCategory'
// import { parseTime } from '@/utils'
import { createModel } from '@/utils/component'
import { selectOptionFormat } from '@/utils/options'
import { /* Language, */ MaterialType } from '@/constant/options'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store'
import networkConfig from '@/config/default/net.config'
import { Route } from '@/constant/route'

export default defineComponent({
  components: {
    Container,
    SearchForm,
    SimpleTable,
    CenterForm,
    NomalContainer,
    UploadFormItem
  },
  setup() {
    const { t } = useI18n()
    const searchFormRef = ref(ElForm)
    const updateUpload = ref()
    const createUpload = ref()
    // const lOptions = selectOptionFormat(Language.languageOptions, t, Language.i18nKey)
    const materialTypeOption = selectOptionFormat(MaterialType.materialTypeOptions, t, MaterialType.i18nKey)
    const searchStruct = [
      { prop: 'templateName', label: t('templatePreset.templateName'), placeholder: t('templatePreset.templateNameP'), component: 'el-input', type: 'text', model: null },
      {
        prop: 'presetCategoryId',
        label: t('templatePreset.presetCategoryId'),
        placeholder: t('templatePreset.presetCategoryIdP'),
        component: 'el-select',
        model: '',
        filterable: true,
        remote: true,
        loading: false,
        remoteMethod: async(query: string) => { console.log(query) },
        options: [] as any
      },
      { prop: 'labelWidth', label: t('templatePreset.labelWidth'), placeholder: t('templatePreset.labelWidthP'), component: 'el-input', type: 'number', model: null },
      { prop: 'labelLength', label: t('templatePreset.labelLength'), placeholder: t('templatePreset.labelLengthP'), component: 'el-input', type: 'number', model: null },
      // { prop: 'targetLanguage', label: t('templatePreset.targetLanguage'), placeholder: t('templatePreset.targetLanguageP'), component: 'el-input', type: 'text', model: null },
      { prop: 'materialType', label: t('templatePreset.materialType'), placeholder: t('templatePreset.materialTypeP'), component: 'el-select', type: 'number', model: null, options: materialTypeOption }
    ]

    const createStruct = [
      { prop: 'templateName', label: t('templatePreset.templateName'), placeholder: t('templatePreset.templateNameP'), component: 'el-input', type: 'text', model: null },
      {
        prop: 'presetCategoryId',
        label: t('templatePreset.presetCategoryId'),
        placeholder: t('templatePreset.presetCategoryIdP'),
        component: 'el-select',
        model: '',
        filterable: true,
        remote: true,
        loading: false,
        remoteMethod: async(query: string) => { console.log(query) },
        options: [] as any
      },
      // { prop: 'labelThumbnail', label: t('templatePreset.labelThumbnail'), placeholder: t('templatePreset.labelThumbnailP'), component: 'el-input', type: 'text', model: null },
      { prop: 'labelContent', label: t('templatePreset.labelContent'), placeholder: t('templatePreset.labelContentP'), component: 'el-input', type: 'textarea', model: null },
      { prop: 'labelWidth', label: t('templatePreset.labelWidth'), placeholder: t('templatePreset.labelWidthP'), component: 'el-input', type: 'number', model: null },
      { prop: 'labelLength', label: t('templatePreset.labelLength'), placeholder: t('templatePreset.labelLengthP'), component: 'el-input', type: 'number', model: null },
      // { prop: 'targetLanguage', label: t('templatePreset.targetLanguage'), placeholder: t('templatePreset.targetLanguageP'), component: 'el-input', type: 'text', model: null },
      { prop: 'materialType', label: t('templatePreset.materialType'), placeholder: t('templatePreset.materialTypeP'), component: 'el-select', type: 'number', model: null, options: materialTypeOption }
    ]

    const updateStruct = [
      { prop: 'templateName', label: t('templatePreset.templateName'), placeholder: t('templatePreset.templateNameP'), component: 'el-input', type: 'text', model: null },
      {
        prop: 'presetCategoryId',
        label: t('templatePreset.presetCategoryId'),
        placeholder: t('templatePreset.presetCategoryIdP'),
        component: 'el-select',
        model: '',
        filterable: true,
        remote: true,
        loading: false,
        remoteMethod: async(query: string) => { console.log(query) },
        options: [] as any
      },
      // { prop: 'labelThumbnail', label: t('templatePreset.labelThumbnail'), placeholder: t('templatePreset.labelThumbnailP'), component: 'el-input', type: 'text', model: null },
      { prop: 'labelContent', label: t('templatePreset.labelContent'), placeholder: t('templatePreset.labelContentP'), component: 'el-input', type: 'textarea', model: null },
      { prop: 'labelWidth', label: t('templatePreset.labelWidth'), placeholder: t('templatePreset.labelWidthP'), component: 'el-input', type: 'number', model: null },
      { prop: 'labelLength', label: t('templatePreset.labelLength'), placeholder: t('templatePreset.labelLengthP'), component: 'el-input', type: 'number', model: null },
      // { prop: 'targetLanguage', label: t('templatePreset.targetLanguage'), placeholder: t('templatePreset.targetLanguageP'), component: 'el-input', type: 'text', model: null },
      { prop: 'materialType', label: t('templatePreset.materialType'), placeholder: t('templatePreset.materialTypeP'), component: 'el-select', type: 'number', model: null, options: materialTypeOption }
    ]

    const templatePresetRole = {
      templateName: [{ required: true, message: t('templatePreset.templateName').concat(t('common.isRequired')), trigger: 'blur' }],
      presetCategoryId: [{ required: true, message: t('templatePreset.presetCategoryId').concat(t('common.isRequired')), trigger: 'blur' }],
      // labelThumbnail: [{ required: true, message: t('templatePreset.labelThumbnail').concat(t('common.isRequired')), trigger: 'blur' }],
      labelContent: [{ required: true, message: t('templatePreset.labelContent').concat(t('common.isRequired')), trigger: 'blur' }],
      labelWidth: [{ required: true, message: t('templatePreset.labelWidth').concat(t('common.isRequired')), trigger: 'blur' }],
      labelLength: [{ required: true, message: t('templatePreset.labelLength').concat(t('common.isRequired')), trigger: 'blur' }],
      // targetLanguage: [{ required: true, message: t('templatePreset.targetLanguage').concat(t('common.isRequired')), trigger: 'blur' }],
      materialType: [{ required: true, message: t('templatePreset.materialType').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const templatePresetCreateRole = {
      templateName: [{ required: true, message: t('templatePreset.templateName').concat(t('common.isRequired')), trigger: 'blur' }],
      presetCategoryId: [{ required: true, message: t('templatePreset.presetCategoryId').concat(t('common.isRequired')), trigger: 'blur' }],
      labelThumbnail: [{ validator: () => createUpload.value ? !createUpload.value.validateUpload() : false, message: t('materialType.labelSizeImage').concat(t('common.isRequired')), trigger: 'blur' }],
      labelContent: [{ required: true, message: t('templatePreset.labelContent').concat(t('common.isRequired')), trigger: 'blur' }],
      labelWidth: [{ required: true, message: t('templatePreset.labelWidth').concat(t('common.isRequired')), trigger: 'blur' }],
      labelLength: [{ required: true, message: t('templatePreset.labelLength').concat(t('common.isRequired')), trigger: 'blur' }],
      materialType: [{ required: true, message: t('templatePreset.materialType').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const tableStruct = [
      { prop: 'templateName', label: t('templatePreset.templateName'), sortable: 'custom' },
      { prop: 'categoryName', label: t('templatePreset.presetCategoryId'), sortable: 'custom' },
      { prop: 'labelThumbnail', label: t('templatePreset.labelThumbnail'), sortable: 'custom', img: 'labelThumbnail' },
      { prop: 'labelWidth', label: t('templatePreset.labelWidth'), sortable: 'custom' },
      { prop: 'labelLength', label: t('templatePreset.labelLength'), sortable: 'custom' },
      // { prop: 'targetLanguage', label: t('templatePreset.targetLanguage'), sortable: 'custom' },
      { prop: 'materialType', label: t('templatePreset.materialType'), formatter: (row: TemplatePresetViewModel) => { return materialTypeOption.find(mt => mt.value === row.materialType)?.label }, sortable: 'custom' }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as TemplatePresetSearchModel,
      tableData: Array<TemplatePresetViewModel>(),
      columnStruct: tableStruct,
      listLoading: true,
      selection: Array<number>(),
      limit: 10,
      total: 0,
      page: 1,
      sort: 'createTime',
      order: 'desc',
      dialogStatus: 'create',
      textMap: {
        update: 'templatePreset.edit',
        create: 'templatePreset.create',
        updateThumbnail: 'templatePreset.edit'
      },
      dialogFormVisible: false,
      templatePresetRole: templatePresetRole,
      templatePresetCreateRole: templatePresetCreateRole,
      createStruct: createStruct,
      createModel: createModel(createStruct) as TemplatePresetAddModel,
      updateStruct: updateStruct,
      updateModel: createModel(updateStruct) as TemplatePresetUpdateModel,
      updateThumbnailModel: {} as any,
      editRow: {} as TemplatePresetModel,
      loadingUpload: null as any,
      updateThumbnailRow: {} as TemplatePresetModel,
      handleSelection(item: any[]) {
        dataMap.selection = item
      },
      handleCurrentChange(page?: any) {
        dataMap.page = page
        dataMap.getList()
      },
      handleSizeChange(val: any) {
        dataMap.limit = val
        dataMap.getList()
      },
      handleOrder(column: any) {
        dataMap.sort = column.prop
        dataMap.order = column.order === 'descending' ? 'desc' : 'asc'
        dataMap.getList()
      },
      async getList() {
        dataMap.listLoading = true
        const params: TemplatePresetPageSearchModel = {
          templateName: dataMap.searchFormModel.templateName,
          presetCategoryId: dataMap.searchFormModel.presetCategoryId,
          labelThumbnail: dataMap.searchFormModel.labelThumbnail,
          labelContent: dataMap.searchFormModel.labelContent,
          labelWidth: dataMap.searchFormModel.labelWidth,
          labelLength: dataMap.searchFormModel.labelLength,
          targetLanguage: dataMap.searchFormModel.targetLanguage,
          materialType: dataMap.searchFormModel.materialType,
          page: dataMap.page,
          limit: dataMap.limit,
          sort: dataMap.sort,
          order: dataMap.order
        }
        const data = await pageSearchTemplatePreset(params)
        dataMap.tableData = data?.data?.records ?? []
        const total = data?.data?.total ?? '0'
        dataMap.total = parseInt(total)

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getList()
      },
      resetForm() {
        console.log('reset')
      },
      async createSubmit() {
        if (createUpload.value.validateUpload()) {
          return
        }
        dataMap.loadingUpload = ElLoading.service({
          lock: true,
          text: t('common.uploading'),
          background: 'rgba(0, 0, 0, 0.7)'
        })
        await createUpload.value.submitUpload()
      },
      async updateThumbnailSubmit() {
        if (updateUpload.value.validateUpload()) {
          return
        }
        dataMap.loadingUpload = ElLoading.service({
          lock: true,
          text: t('common.uploading'),
          background: 'rgba(0, 0, 0, 0.7)'
        })
        await updateUpload.value.submitUpload()
      }, /*
      async createSubmit() {
        const createData: TemplatePresetAddModel = {
          templateName: dataMap.createModel.templateName,
          presetCategoryId: dataMap.createModel.presetCategoryId,
          labelThumbnail: dataMap.createModel.labelThumbnail,
          labelContent: dataMap.createModel.labelContent,
          labelWidth: dataMap.createModel.labelWidth,
          labelLength: dataMap.createModel.labelLength,
          targetLanguage: dataMap.createModel.targetLanguage,
          materialType: dataMap.createModel.materialType
        }
        const result = await addTemplatePreset(createData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.createSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      }, */
      async updateNameSubmit() {
        const updateData: TemplatePresetUpdateModel = {
          id: dataMap.updateModel.id,
          templateName: dataMap.updateModel.templateName,
          presetCategoryId: dataMap.updateModel.presetCategoryId,
          labelContent: dataMap.updateModel.labelContent,
          labelWidth: dataMap.updateModel.labelWidth,
          labelLength: dataMap.updateModel.labelLength,
          targetLanguage: dataMap.updateModel.targetLanguage,
          materialType: dataMap.updateModel.materialType
        }
        const result = await updateTemplatePreset(updateData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async deleteData(id: number) {
        const result = await removeTemplatePreset(id)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async bathDeleteData() {
        const deleteData: IdsModel = { ids: dataMap.selection }
        const result = await batchRemoveTemplatePreset(deleteData)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateNameReset() {
        console.log('update reset')
        dataMap.updateModel.id = dataMap.editRow.id
        dataMap.updateModel.templateName = dataMap.editRow.templateName
        dataMap.updateModel.presetCategoryId = dataMap.editRow.presetCategoryId
        dataMap.updateModel.labelContent = dataMap.editRow.labelContent
        dataMap.updateModel.labelWidth = dataMap.editRow.labelWidth
        dataMap.updateModel.labelLength = dataMap.editRow.labelLength
        dataMap.updateModel.targetLanguage = dataMap.editRow.targetLanguage
        dataMap.updateModel.materialType = dataMap.editRow.materialType
      },
      createReset() {
        console.log('create reset')
        if (createUpload.value) {
          createUpload.value.onReset()
        }
      },
      updateThumbnailReset() {
        console.log('update thumbnail reset')
        dataMap.updateThumbnailModel.id = dataMap.updateThumbnailRow.id
        if (updateUpload.value) {
          updateUpload.value.onReset()
        }
      }
    })
    const getIndustryAndCategoryOptions = async(query: string) => {
      if (dataMap.dialogFormVisible) {
        if (dataMap.dialogStatus === 'create') {
          dataMap.createStruct[1].loading = true
        } else if (dataMap.dialogStatus === 'update') {
          dataMap.updateStruct[1].loading = true
        }
      } else {
        dataMap.searchFormStruct[1].loading = true
      }
      const params: IndustryAndCategorySearchModel = {
        categoryName: query,
        fatherCategoryId: null
      }
      const data = await searchIndustryAndCategory(params)
      const list = data?.data ?? []
      const optionList = []
      for (const iterator of list) {
        optionList.push({ label: iterator.categoryName, value: iterator.id })
      }
      if (dataMap.dialogFormVisible) {
        if (dataMap.dialogStatus === 'create') {
          dataMap.createStruct[1].options = optionList
        } else if (dataMap.dialogStatus === 'update') {
          dataMap.updateStruct[1].options = optionList
        }
      } else {
        dataMap.searchFormStruct[1].options = optionList
      }
      dataMap.createStruct[1].loading = false
      dataMap.updateStruct[1].loading = false
      dataMap.searchFormStruct[1].loading = false
    }
    const handleCreate = () => {
      dataMap.dialogStatus = 'create'
      if (createUpload.value) {
        createUpload.value.onReset()
      }
      getIndustryAndCategoryOptions('')
      dataMap.dialogFormVisible = true
    }
    const handleEdit = (row?: TemplatePresetModel) => {
      if (row) {
        dataMap.editRow = row
        dataMap.dialogStatus = 'update'
        dataMap.updateModel.id = row.id
        dataMap.updateModel.templateName = row.templateName
        dataMap.updateModel.presetCategoryId = row.presetCategoryId
        dataMap.updateModel.labelContent = row.labelContent
        dataMap.updateModel.labelWidth = row.labelWidth
        dataMap.updateModel.labelLength = row.labelLength
        dataMap.updateModel.targetLanguage = row.targetLanguage
        dataMap.updateModel.materialType = row.materialType
        getIndustryAndCategoryOptions('')
        dataMap.dialogFormVisible = true
      }
    }
    const handleEditThumbnail = (row?: TemplatePresetModel) => {
      if (row) {
        dataMap.updateThumbnailRow = row
        dataMap.dialogStatus = 'updateThumbnail'
        dataMap.updateThumbnailModel.id = row.id
        dataMap.updateThumbnailReset()
        dataMap.dialogFormVisible = true
      }
    }
    const handleDelete = (id: number) => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.deleteData(id)
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleBathDelete = () => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.bathDeleteData()
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleCreateUpload = (result: any) => {
      console.log(result)
      if (dataMap.loadingUpload) {
        dataMap.loadingUpload.close()
      }
      if (result?.code === 0) {
        ElMessage({
          message: t('common.createSuccess'),
          type: 'success',
          duration: 2000
        })
        dataMap.dialogFormVisible = false
        dataMap.getList()
      } else {
        ElMessage({
          message: result?.message,
          type: 'error',
          duration: 2000
        })
      }
    }
    const handleUpdateUpload = (result: any) => {
      console.log(result)
      if (dataMap.loadingUpload) {
        dataMap.loadingUpload.close()
      }
      if (result?.code === 0) {
        ElMessage({
          message: t('common.updateSuccess'),
          type: 'success',
          duration: 2000
        })
        dataMap.dialogFormVisible = false
        dataMap.getList()
      } else {
        ElMessage({
          message: result?.message,
          type: 'error',
          duration: 2000
        })
      }
    }
    const getCreateUploadUri = () => {
      return networkConfig.host + Route.product + '/templatePreset/add'
    }
    const getUpdateUploadUri = () => {
      return networkConfig.host + Route.product + '/templatePreset/update/thumbnail'
    }
    const getUploadHeader = () => {
      return {
        Authorization: 'Bearer ' + useStore().state.user.token
      }
    }
    onMounted(() => {
      dataMap.getList()
      dataMap.searchFormStruct[1].remoteMethod = getIndustryAndCategoryOptions
      dataMap.createStruct[1].remoteMethod = getIndustryAndCategoryOptions
      dataMap.updateStruct[1].remoteMethod = getIndustryAndCategoryOptions
      getIndustryAndCategoryOptions('')
    })
    return {
      t,
      handleCreate,
      handleEdit,
      handleDelete,
      handleBathDelete,
      handleEditThumbnail,
      searchFormRef,
      getCreateUploadUri,
      getUpdateUploadUri,
      getUploadHeader,
      handleCreateUpload,
      handleUpdateUpload,
      createUpload,
      updateUpload,
      ...toRefs(dataMap)
    }
  }
})
</script>
